import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actions } from "react-redux-form";
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { InputFieldFloatingLabel as InputField, SelectFieldFloatingLabel as Select} from '../../../../../common/custom-form/select-filter.component';
import DATEPICKER_OR from '../../../../../common/custom-form/custom-date-picker.component';
import { TRANSLATIONS as translation } from "../../../../../../utils/constant.utils";
import { MAX_LENGTH, DATA_TYPE, FiveDecimalPlaces, RECHARGE_INVENTORY_TYPE, WORKFLOW_MESSAGE} from '../../../../../../constants/external-constants';
import MappingInformation from '../../recharging-details-inventory/mapping-information/mapping-information.component';
import LocationInformation from '../../recharging-details-inventory/location-information/location-information.component';
import { ConfirmationModal } from '../../../../../common/modal/modal.component';
import { NotificationModal } from '../../../../../common/modal/notification-modal.component';
import OtcAdditionalInformation from '../otc-additional-information/otc-additional-information';
import { RechargeInventoryDetailsActions } from '../../../../../../store/external/recharge-reducer/recharge-inventory-details.reducer/recharge-inventory-details.reducer';
import { generateOtcNumber, isObjectEqual, areDataEqual } from '../../../../../../utils/helpers.utils';
import { NoSubscription } from '../../../../dashboard/no-subscription/no-subscription.component';
import { ACCESS_MODULE, MATRIX_INDICATOR } from '../../../../../../utils/rbac-constants.utils';
import { validateAccessModule } from '../../../../../../utils/helpers.utils';
import CustomSearchableDropdownWrapper from '../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper';
class RechargingOtcForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            isLoading: false,
            isSaving: false,
            originalMappingInformationData: {},
        }
        this.ConfirmationModal = React.createRef();
    }

    async componentDidMount() {
        const { rechargeInventoryDetailsForm, isCreateNew, setOtcNumber, setFormDefaultDetails, getRechargeInventory, rechargeInventoryId, getMappingInformationList } = this.props;

        this.setState({ isLoading: true });

        if (isCreateNew) {
            this.props.resetRechargeInventoryDetailForm();
            if (rechargeInventoryDetailsForm.otcInformation.otcNumber === "") {
                const otcNumber = generateOtcNumber();
                setOtcNumber(otcNumber);
            }

            await this.props.getRequestorOption(1);
            await this.props.getRechargingPersonOption(1);
            await this.props.getEndUserOption(1);
            await this.props.getLocationOption(1);
            await this.props.getVendorOption(1);

            setFormDefaultDetails(RECHARGE_INVENTORY_TYPE["OTC"].label);
        }
        else {
            await getRechargeInventory(rechargeInventoryId);

            const { data } = this.props.rechargeInventoryDetails.rechargeInventoryData;

            await this.props.getRequestorOption(1, data.RequestorEmail);
            await this.props.getRechargingPersonOption(1, data.RechargePersonEmail);
            await this.props.getEndUserOption(1, data.EndUserEmail);
            await this.props.getLocationOption(1, data.LocationCode);
            await this.props.getVendorOption(1, data.VendorName);
        }
        await getMappingInformationList(rechargeInventoryId).then(() => {
            const originalMappingInformationDataCopy = JSON.parse(JSON.stringify(this.props.rechargeInventoryDetails.mappingInformationList));
            this.setState({ originalMappingInformationData: originalMappingInformationDataCopy })
        });

        this.setState({ isLoading: false });
    }

    componentWillUnmount() {
        this.props.resetRechargeInventoryDetailForm();
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    handleChangesStatus = (prop, truthValue) => {
        this.setState({
            [prop]: truthValue
        })
    }

    disableSaveChanges = () => {
        const { $form, rechargeInventoryDetailsForm, rechargeInventoryDetails, isCreateNew } = this.props;
        const { rechargeInventory, additionalInformation, locationInformation, otcInformation } = rechargeInventoryDetailsForm;
        const { operationalStatusId, rechargeQuantity } = rechargeInventory;
        const { otcDDI, otcTypeId, activationDate } = otcInformation;
        const { locationId } = locationInformation;

        const isFieldEmpty = !otcDDI || !otcTypeId || !operationalStatusId || !activationDate || !rechargeQuantity || !locationId;

        if (isFieldEmpty) {
            return true;
        }

        if (!isCreateNew) {

            const loaded = $form?.loadedValue;
            const unchangedRechargeInventoryDetails = !loaded || isObjectEqual(loaded.rechargeInventory, rechargeInventory);
            const unchangedOTCInformation = !loaded || isObjectEqual(loaded.otcInformation, otcInformation);
            const unchangedAdditionalInformation = !loaded || isObjectEqual(loaded.additionalInformation, additionalInformation);
            const unchangedLocationInformation = !loaded || parseInt(loaded.locationInformation?.locationId) === parseInt(locationId);
            const mappingInformationDetails = rechargeInventoryDetails?.mappingInformationList?.datatable?.length > 0
                ? areDataEqual(this.state.originalMappingInformationData?.datatable?.[0], rechargeInventoryDetails.mappingInformationList.datatable[0])
                : true;
            return unchangedRechargeInventoryDetails && unchangedAdditionalInformation && unchangedLocationInformation && unchangedOTCInformation && mappingInformationDetails;
        }

        return false;

    }

    handleButtonConfirmation = async (rechargeInventoryId) => {
        const { saveRechargeInventory, getRechargeInventory, getMappingInformationList } = this.props;

        this.setState({
            isSaving: true
        });

        var result = await saveRechargeInventory(rechargeInventoryId);
        getRechargeInventory(rechargeInventoryId);

        this.setState({
            isSaving: false
        });

        if (result.success === true) {
            // Refresh form with updated values
            await getRechargeInventory(rechargeInventoryId);
            getMappingInformationList(rechargeInventoryId).then(() => {
                const originalMappingInformationDataCopy = JSON.parse(JSON.stringify(this.props.rechargeInventoryDetails.mappingInformationList));
                this.setState({ originalMappingInformationData: originalMappingInformationDataCopy })
            });

            this.toggleSaveNotif(true, this.toLocaleLanguage("success_modal_title"), result.message);
            return;
        }
        else {
            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);
            return;
        }
    }

    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif } = this.state;
        const { handleCloseForm, resetRechargeInventoryDetailForm } = this.props

        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });

        if (!isShow && saveNotif.message === this.toLocaleLanguage("otc_created")) {
            handleCloseForm();
            resetRechargeInventoryDetailForm();
        }
    }
    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    loadUpdatedMappingInfo = (data) => {
        this.setState({
            originalMappingInformationData: data
        })
    }

    handleRechargingPersonSearch = (searchString) => {
        this.props.getRechargingPersonOption(1, searchString)
    }

    loadMoreRechargingPerson = (searchString) => {
        const { rechargingPersonPage } = this.props.rechargeInventoryDetails;

        this.props.getRechargingPersonOption(rechargingPersonPage + 1, searchString);
    }

    handleRequestorSearch = (searchString) => {
        this.props.getRequestorOption(1, searchString)
    }

    loadMoreRequestor = (searchString) => {
        const { requestorPage } = this.props.rechargeInventoryDetails;

        this.props.getRequestorOption(requestorPage + 1, searchString);
    }

    handleEndUserSearch = (searchString) => {
        this.props.getEndUserOption(1, searchString)
    }

    loadMoreEndUser = (searchString) => {
        const { endUserPage } = this.props.rechargeInventoryDetails;

        this.props.getEndUserOption(endUserPage + 1, searchString);
    }

    handleVendorSearch = (searchString) => {
        this.props.getVendorOption(1, searchString)
    }

    loadMoreVendor = (searchString) => {
        const { vendorPage } = this.props.rechargeInventoryDetails;

        this.props.getVendorOption(vendorPage + 1, searchString);
    }

    render() {
        const { rechargeInventoryDetails, rechargeInventoryDetailsForm, isCreateNew } = this.props;
        const hasNotification = rechargeInventoryDetails.mappingInformationList?.datatable[0]?.dataItem.length > 0 ?
            (rechargeInventoryDetails.mappingInformationList?.datatable[0]?.dataItem[0].MappingStatusID == 3
                || rechargeInventoryDetails.mappingInformationList?.datatable[0]?.dataItem[0].MappingStatusID == 4) : false;
        
        const isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingInventoryRW])
        return (
            <>
                {this.state.isSaving || this.state.isLoading ? (
                    <NoSubscription />
                ) : (
                    <>
                        <div className="details-field-container capital-uppercase">

                            <InputField
                                className="form-control required"
                                type="text"
                                label={`${this.toLocaleLanguage('otc_number')}`}
                                value={rechargeInventoryDetailsForm.otcInformation.otcNumber}
                                fieldProp='rechargeInventoryDetailsForm.otcInformation.otcNumber'
                                placeholder={`${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                                disabled={true}
                                inputType={DATA_TYPE.decimal}
                            />
                            <InputField
                                className="form-control required"
                                type="text"
                                label={`${this.toLocaleLanguage('otc_ddi')}`}
                                value={rechargeInventoryDetailsForm.otcInformation.otcDDI}
                                fieldProp='rechargeInventoryDetailsForm.otcInformation.otcDDI'
                                placeholder={`${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                                maxLength={MAX_LENGTH.limit_100}
                            />
                            <Select
                                className="form-select required"
                                label={`${this.toLocaleLanguage('otc_type')}`}
                                options={rechargeInventoryDetails.rechargeInventoryDetailsDropDownList?.OTCType}
                                value={rechargeInventoryDetailsForm.otcInformation.otcTypeId}
                                placeholder={this.toLocaleLanguage('select_placeholder', false)}
                                isError={false}
                                fieldProp="rechargeInventoryDetailsForm.otcInformation.otcTypeId"
                                optionLabelKey={{
                                    Key: "Key",
                                    Value: "Value"
                                }}
                            />

                            <Select
                                className="form-select required"
                                label={`${this.toLocaleLanguage('operational_status')}`}
                                options={rechargeInventoryDetails.rechargeInventoryDetailsDropDownList?.OperationalStatus}
                                value={rechargeInventoryDetailsForm.rechargeInventory.operationalStatusId}
                                placeholder={this.toLocaleLanguage('select_placeholder', false)}
                                isError={false}
                                fieldProp="rechargeInventoryDetailsForm.rechargeInventory.operationalStatusId"
                                onChangeAction={this.onChangeDisputeType}
                                optionLabelKey={{
                                    Key: "Key",
                                    Value: "Value"
                                }}
                            />
                            <InputField
                                className="form-control"
                                type="text"
                                label={`${this.toLocaleLanguage('recharging_inventory_type')}`}
                                value={rechargeInventoryDetailsForm.rechargeInventory.rechargeInventoryType}
                                fieldProp='rechargeInventoryDetailsForm.rechargeInventory.rechargeInventoryType'
                                placeholder={`${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                                disabled={true}
                            />

                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('vendor')}`}
                                options={rechargeInventoryDetails.vendorOptions}
                                selected={rechargeInventoryDetailsForm.rechargeInventory.vendorId}
                                fieldProp='rechargeInventoryDetailsForm.rechargeInventory.vendorId'
                                tagName='subCircuitTypeID'
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                placeholder={`${this.toLocaleLanguage('select_placeholder', false)}`}
                                maxLength={MAX_LENGTH.limit_100}

                                onSearchChange={this.handleVendorSearch}
                                onLoadMore={this.loadMoreVendor}
                                isLoading={rechargeInventoryDetails.isVendorLoading}
                                hasMore={rechargeInventoryDetails.hasMoreVendor}
                            />
                            <DATEPICKER_OR
                                dateOnly={true}
                                label={`${this.toLocaleLanguage('activation_date')}`}
                                placeholder={`${this.toLocaleLanguage('select_placeholder', false)}`}
                                startDate={rechargeInventoryDetailsForm.otcInformation.activationDate}
                                selectedDate={(date) => this.props.FormChange("rechargeInventoryDetailsForm.otcInformation.activationDate", date)}
                                requiredField={true}
                            />

                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('end_user')}`}
                                options={rechargeInventoryDetails.endUserOptions}
                                selected={rechargeInventoryDetailsForm.rechargeInventory.endUserId}
                                fieldProp='rechargeInventoryDetailsForm.rechargeInventory.endUserId'
                                tagName='subCircuitTypeID'
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                placeholder={`${this.toLocaleLanguage('select_placeholder', false)}`}
                                maxLength={MAX_LENGTH.limit_100}

                                onSearchChange={this.handleEndUserSearch}
                                onLoadMore={this.loadMoreEndUser}
                                isLoading={rechargeInventoryDetails.isEmployeeLoading}
                                hasMore={rechargeInventoryDetails.hasMoreEndUser}
                            />
                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('requestor')}`}
                                options={rechargeInventoryDetails.requestorOptions}
                                selected={rechargeInventoryDetailsForm.rechargeInventory.requestorId}
                                fieldProp='rechargeInventoryDetailsForm.rechargeInventory.requestorId'
                                tagName='subCircuitTypeID'
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                placeholder={`${this.toLocaleLanguage('select_placeholder', false)}`}
                                maxLength={MAX_LENGTH.limit_100}

                                onSearchChange={this.handleRequestorSearch}
                                onLoadMore={this.loadMoreRequestor}
                                isLoading={rechargeInventoryDetails.isEmployeeLoading}
                                hasMore={rechargeInventoryDetails.hasMoreRequestor}
                            />

                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('recharging_person')}`}
                                options={rechargeInventoryDetails.rechargingPersonOptions}
                                selected={rechargeInventoryDetailsForm.rechargeInventory.rechargePersonId}
                                fieldProp='rechargeInventoryDetailsForm.rechargeInventory.rechargePersonId'
                                tagName='subCircuitTypeID'
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                placeholder={`${this.toLocaleLanguage('select_placeholder', false)}`}
                                maxLength={MAX_LENGTH.limit_100}

                                onSearchChange={this.handleRechargingPersonSearch}
                                onLoadMore={this.loadMoreRechargingPerson}
                                isLoading={rechargeInventoryDetails.isEmployeeLoading}
                                hasMore={rechargeInventoryDetails.hasMoreRechargingPerson}
                            />

                            <InputField
                                className="form-control"
                                type="text"
                                label={`${this.toLocaleLanguage('recharging_quantity')}`}
                                value={rechargeInventoryDetailsForm.rechargeInventory.rechargeQuantity}
                                fieldProp='rechargeInventoryDetailsForm.rechargeInventory.rechargeQuantity'
                                placeholder={`${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                                decimalPlaces={FiveDecimalPlaces}
                                requiredField
                                hasDecimalLimit={true}
                                decimalFormat={[18, 5]}
                            />

                            <InputField
                                className="form-control"
                                type="text"
                                label={`${this.toLocaleLanguage('service_instance_id')}`}
                                value={rechargeInventoryDetailsForm.rechargeInventory.serviceInstanceId}
                                fieldProp='rechargeInventoryDetailsForm.rechargeInventory.serviceInstanceId'
                                placeholder={`${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                                maxLength={MAX_LENGTH.limit_255}
                            />

                            <InputField
                                className="form-control"
                                type="text"
                                label={`${this.toLocaleLanguage('output_record_id')}`}
                                value={rechargeInventoryDetailsForm.rechargeInventory.outputRecordId}
                                fieldProp='rechargeInventoryDetailsForm.rechargeInventory.outputRecordId'
                                disabled={true}
                            />


                        </div>
                        <div className="collapsable-items-wrapper">
                            <div className="horizontal-separator" />
                            <MappingInformation
                                isCreateNew={isCreateNew}
                                rechargeInventoryId={this.props.rechargeInventoryId}
                                translator={this.toLocaleLanguage}
                                handleChangesStatus={this.handleChangesStatus}
                                loadUpdatedMappingInfo={this.loadUpdatedMappingInfo}
                                originalMappingInformationData={this.state.originalMappingInformationData}
                                isReadAndWrite={isReadAndWrite}
                            />
                            <OtcAdditionalInformation translator={this.toLocaleLanguage} />
                            <LocationInformation translator={this.toLocaleLanguage} />
                            </div>
                            {hasNotification ?
                                <span className="pending-approval-message">{WORKFLOW_MESSAGE.refreshMappingWorkflow}</span>
                                : ''
                            }
                        <div className='save-btn-container'>
                            <ConfirmationModal
                                ref={this.ConfirmationModal}
                                title={this.state.saveModal.title}
                                messageBody={this.state.saveModal.messageBody}
                                confirmAction={this.state.saveModal.confirmAction}
                                closeLabel={this.toLocaleLanguage("cancel_button")}
                                confirmLabel={this.toLocaleLanguage("yes_button")}
                                disabled={this.state.isSaving}
                            />

                            <NotificationModal
                                show={this.state.saveNotif.show}
                                title={this.state.saveNotif.title}
                                message={this.state.saveNotif.message}
                                handleModal={() => this.toggleSaveNotif(false)}
                                customClass={'comment-notification-modal modal-text-bold notification-footer'}
                            />

                            {
                                isReadAndWrite &&
                                    <div className="tooltip-container">
                                        <div className="btn-tooltiptext">
                                            {true ?
                                                <Button className='save-details-btn btn btn-primary'
                                                    disabled={this.disableSaveChanges()}
                                                    onClick={() => this.handleButtonConfirmation(this.props.rechargeInventoryId)}
                                                    type="button">
                                                    Save Changes
                                                </Button>
                                                : null}
                                            <div className="save-tooltip-text-container">
                                                <span className="tooltip-text-save">{this.toLocaleLanguage("save_otc_information", false)}</span>
                                            </div>
                                        </div>
                                    </div>
                            }
                            
                        </div>
                    </>
                )}
            </>
        );
    }
}

export default withRouter(connect(
    state => {
        const { rechargeInventoryDetails, translation } = state;
        const { rechargeInventoryDetailsForm, forms: { rechargeInventoryDetailsForm: { $form } } } = state.form;
        return {
            ...translation,
            rechargeInventoryDetails,
            rechargeInventoryDetailsForm,
            $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, RechargeInventoryDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        },
        FormLoad: (model, data) => {
            dispatch(actions.load(model, data));
        }
    })
)(RechargingOtcForm));